import { useCallback, useState } from "react";

interface UseChartZoomReturn {
    isZoomed: boolean;
    openZoom: () => void;
    closeZoom: () => void;
    toggleZoom: () => void;
}

const useChartZoom = (): UseChartZoomReturn => {
    const [isZoomed, setIsZoomed] = useState(false);

    const openZoom = useCallback(() => {
        setIsZoomed(true);
    }, []);

    const closeZoom = useCallback(() => {
        setIsZoomed(false);
    }, []);

    const toggleZoom = useCallback(() => {
        setIsZoomed((prev) => !prev);
    }, []);

    return {
        isZoomed,
        openZoom,
        closeZoom,
        toggleZoom,
    };
};

export default useChartZoom;
